var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',_vm._b({staticClass:"table-box"},'table',_vm.$props,false),[_c('thead',{staticClass:"table-box-header"},[_vm._t("header",function(){return [_c('div')]})],2),_vm._v(" "),_c('tbody',{staticClass:"table-box-body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }